import styled from 'styled-components'

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  justify-items: center;
  padding: 5px 18px;
`
